module.exports = __webpack_public_path__ + "static/media/website.b5080ded.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/website.png
// module id = 1268
// module chunks = 0